import {
  FLAG_CATEGORIES,
  type FlagCategory,
  type FlagDefinition,
} from "~/features/feature-flags/shared/registry"

export const CATEGORY_FILTERS = ["all", ...FLAG_CATEGORIES] as const
export type CategoryFilterValue = (typeof CATEGORY_FILTERS)[number]

export const inCategory = (filter: CategoryFilterValue, category: FlagCategory) =>
  filter === "all" || filter === category

/** Case-insensitive substring match of the trimmed search against any field. */
export const matchesSearch = (search: string, ...fields: (string | undefined)[]) => {
  const query = search.trim().toLowerCase()
  return !query || fields.some((field) => field?.toLowerCase().includes(query))
}

/** A flag in the category, matching the search on its key, name, description or owner. */
export const matchesFlag = (
  key: string,
  definition: FlagDefinition,
  category: CategoryFilterValue,
  search: string,
) =>
  inCategory(category, definition.category) &&
  matchesSearch(search, key, definition.name, definition.description, definition.owner)

export const NO_MATCHES = "No matches."
